(() => {
  function initialiseCardSwatches(scope = document) {
    const swatchGroups = scope.querySelectorAll(
      '.buatia-card-swatches:not([data-buatia-initialized])'
    );

    swatchGroups.forEach((group) => {
      group.dataset.buatiaInitialized = 'true';

      const cardWrapper = group.closest('.card-wrapper');

      if (!cardWrapper) return;

      const cardImages = cardWrapper.querySelectorAll(
        '.card__media .media > img'
      );

      const primaryImage = cardImages[0];
      const secondaryImage = cardImages[1];

      if (!primaryImage) return;

      const cardLinks = cardWrapper.querySelectorAll(
        'a[href*="/products/"]'
      );

      const cardTitleLinks = cardWrapper.querySelectorAll(
        '.card__heading a'
      );

      /**
       * Actualiza una imagen de la tarjeta.
       */
      const updateImage = (image, src, srcset, alt) => {
        if (!image || !src) return;

        image.setAttribute('src', src);

        if (srcset) {
          image.setAttribute('srcset', srcset.trim());
        } else {
          image.removeAttribute('srcset');
        }

        image.setAttribute('alt', alt || '');
      };

      /**
       * Cambia la tarjeta al color seleccionado.
       */
      const selectColour = (selectedSwatch) => {
        if (selectedSwatch.classList.contains('is-active')) {
          return;
        }

        const selectedUrl =
          selectedSwatch.dataset.buatiaProductUrl;

        const selectedTitle =
          selectedSwatch.dataset.buatiaProductTitle;

        /*
         * Inicia el fundido de la imagen.
         */
        cardWrapper.classList.add('buatia-card-swapping');

        window.setTimeout(() => {
          /*
           * Cambia la primera imagen.
           */
          updateImage(
            primaryImage,
            selectedSwatch.dataset.buatiaPrimarySrc,
            selectedSwatch.dataset.buatiaPrimarySrcset,
            selectedSwatch.dataset.buatiaPrimaryAlt
          );

          /*
           * Cambia la segunda imagen utilizada por
           * el hover nativo de Craft.
           */
          if (
            secondaryImage &&
            selectedSwatch.dataset.buatiaSecondarySrc
          ) {
            updateImage(
              secondaryImage,
              selectedSwatch.dataset.buatiaSecondarySrc,
              selectedSwatch.dataset.buatiaSecondarySrcset,
              selectedSwatch.dataset.buatiaSecondaryAlt
            );
          }

          /*
           * Marca visualmente el círculo seleccionado.
           */
          group
            .querySelectorAll('.buatia-card-swatches__option')
            .forEach((swatch) => {
              const isSelected = swatch === selectedSwatch;

              swatch.classList.toggle('is-active', isSelected);
              swatch.setAttribute(
                'aria-pressed',
                isSelected ? 'true' : 'false'
              );
            });

          /*
           * Actualiza los enlaces de la imagen y del título.
           */
          if (selectedUrl) {
            cardLinks.forEach((link) => {
              link.setAttribute('href', selectedUrl);
            });
          }

          /*
           * Actualiza el nombre visible del producto.
           */
          if (selectedTitle) {
            cardTitleLinks.forEach((titleLink) => {
              titleLink.textContent = selectedTitle;
            });
          }

          /*
           * Termina el fundido.
           */
          window.requestAnimationFrame(() => {
            cardWrapper.classList.remove(
              'buatia-card-swapping'
            );
          });
        }, 160);
      };

      /*
       * Los círculos cambian la previsualización
       * sin navegar inmediatamente al producto.
       */
      group
        .querySelectorAll('.buatia-card-swatches__option')
        .forEach((swatch) => {
          swatch.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();

            selectColour(swatch);
          });
        });
    });
  }

  function start() {
    initialiseCardSwatches(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  /*
   * Reinicializa las tarjetas si Shopify vuelve
   * a cargar una sección en el editor visual.
   */
  document.addEventListener('shopify:section:load', (event) => {
    initialiseCardSwatches(event.target);
  });
})();

/* =========================================================
   INITIAL SELECTOR - REQUIRED
   ========================================================= */

document.addEventListener('click', function (event) {
  const submitButton = event.target.closest(
    'button[name="add"], product-form button[type="submit"]'
  );

  if (!submitButton) return;

  const productInfo = submitButton.closest('product-info');
  if (!productInfo) return;

  const initialSelect = productInfo.querySelector('.buatia-initial-selector select');
  if (!initialSelect) return;

  if (!initialSelect.value) {
    event.preventDefault();
    event.stopImmediatePropagation();

    initialSelect.setCustomValidity('Selecciona una inicial.');
    initialSelect.reportValidity();
    initialSelect.focus();

    return;
  }

  initialSelect.setCustomValidity('');
});

document.addEventListener('change', function (event) {
  if (event.target.matches('.buatia-initial-selector select')) {
    event.target.setCustomValidity('');
  }
});

/* =========================================================
   BUATÍA - VÍDEOS EN DESPLEGABLES
   ========================================================= */

(function () {
  function setupAccordionVideos(root) {
    root.querySelectorAll('.product__accordion details').forEach(function (details) {
      if (details.dataset.buatiaVideoReady === 'true') return;

      var videos = details.querySelectorAll('.buatia-accordion-video');
      if (!videos.length) return;

      details.dataset.buatiaVideoReady = 'true';

      function updateVideos() {
        videos.forEach(function (video) {
          if (details.open) {
            video.play().catch(function () {
              // El navegador puede bloquear la reproducción automática.
            });
          } else {
            video.pause();
          }
        });
      }

      details.addEventListener('toggle', updateVideos);

      updateVideos();
    });
  }

  function init() {
    setupAccordionVideos(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    setupAccordionVideos(event.target);
  });
})();